
<!--
 * @Description: 教职工详情 专业能力与资格证书
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2024-10-15 16:40:30
-->
<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="证书名称" label-align="right" align="left" width="150px" span="2">{{item.zsmc}}</el-descriptions-item>
      <el-descriptions-item label="证书编号" label-align="right" align="left" width="150px" span="2">{{item.zsbh}}</el-descriptions-item>
      <el-descriptions-item label="证书颁发单位" label-align="right" align="left" width="150px" span="2">{{item.zsbfdw}}</el-descriptions-item>
      <el-descriptions-item label="证书颁发日期" label-align="right" align="left" width="150px" span="2">{{item.zsbfrq}}</el-descriptions-item>
      <el-descriptions-item label="证书备注" label-align="right" align="left" width="150px" span="2">{{item.zsbz}}</el-descriptions-item>
      <el-descriptions-item label="是否是职业资格证书" label-align="right" align="left" width="150px" span="2">
        <span v-if="item.sfszyzgzs === true">是</span>
        <span v-if="item.sfszyzgzs === false">否</span>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigongzhuanyenenglizizhizhengshu/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
